import { SvgIcon, SvgIconProps } from '@mui/material';

export default function InvitationsMenuIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 26 24">
      <g fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.3816 18.75H12.0941L5.64414 23.25V18.75H2.41914C1.52858 18.75 0.806641 18.0784 0.806641 17.25V2.25C0.806641 1.42157 1.52858 0.75 2.41914 0.75H23.3816C24.2722 0.75 24.9941 1.42157 24.9941 2.25V17.25C24.9941 18.0784 24.2722 18.75 23.3816 18.75Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.67578 6.74962C9.67609 5.22405 10.9071 3.94163 12.5366 3.76938C14.1661 3.59713 15.6751 4.5899 16.0434 6.07651C16.4117 7.56312 15.522 9.0701 13.9758 9.57862C13.3312 9.79061 12.9004 10.3577 12.9008 10.9936V11.2496"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.9002 14.25C12.6776 14.25 12.4971 14.4179 12.4971 14.625C12.4971 14.8321 12.6776 15 12.9002 15C13.1228 15 13.3033 14.8321 13.3033 14.625C13.3033 14.4179 13.1228 14.25 12.9002 14.25V14.25"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
